import MagicForm from '../../../../../Components/Form/MagicForm';
import React, { useMemo, useState } from 'react';
import { User } from '../../../../../graphql/graphql';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import useWizardTree from '../../../../../Hooks/useWizardTree';
import { HealthPlan } from '../../../../../Services/HealthPlanContext';
import { useEffectAsync } from '../../../../../helpers';

export interface CreateHealthPlanFormValues {
	birthDate: Date;
}

interface Props {
	onSubmit: (values: CreateHealthPlanFormValues) => void;
	patient?: User;
	healthPlan?: HealthPlan;
}

const MeddiDENTCreateHealthPlanForm = ({
	onSubmit,
	patient,
	healthPlan,
}: Props) => {
	const [formScheme, setFormScheme] = useState<ItemScheme[]>([]);
	const [isInitialized, setIsInitialized] = useState(false);

	if (!healthPlan) return null;

	const { getWizard } = useWizardTree({
		wizardKey: 'health-plan-patient-questionnaire',
		params: {
			userId: patient?.id,
			healthPlanCode: healthPlan.code,
		},
	});

	useEffectAsync(async () => {
		const wizard = await getWizard();
		setFormScheme(wizard?.children || []);
		setIsInitialized(true);
	}, []);

	const defaultValues = useMemo(
		() => ({
			birthDate: patient?.profile?.birthDate,
		}),
		[patient?.profile?.birthDate],
	);

	if (!isInitialized) return null;

	return (
		<div className='col-12 col-lg-8'>
			<div className='page-panel mt-1 mb-1'>
				<MagicForm
					formScheme={formScheme}
					defaultValues={defaultValues}
					onSubmit={onSubmit}
				/>
			</div>
		</div>
	);
};

export default MeddiDENTCreateHealthPlanForm;
